import Inventory from "@/views/Inventory/Inventory.vue";
import InventoryManagement from "@/views/Inventory/InventoryManagement.vue";
import ArticleConversions from "@/views/Inventory/ArticleConversions.vue";
import Articles from "@/views/Inventory/Articles.vue";
import Assets from "@/views/Inventory/Assets.vue";
import Adjustments from "@/views/Inventory/Adjustments.vue";
import ComboTransformation from "@/views/Inventory/ComboTransformation.vue";
import Variant from "@/views/Inventory/Variant.vue";
import ViewAdjustment from "@/views/Inventory/ViewAdjustment.vue";
import ViewOutflows from "@/views/Inventory/ViewOutflows.vue";
import Category from "@/views/Inventory/Category.vue";
import Warehouse from "@/views/Inventory/Warehouse.vue";
import ViewWarehouse from "@/components/Inventory/ViewWarehouse.vue";
import Catalogue from "@/views/Inventory/Catalogue.vue";
import TransferRequest from "@/views/Inventory/Transfers/Request.vue";
import MovementBtLocations from "@/views/Inventory/Transfers/MovementBtLocations.vue";
import Approvals from "@/views/Inventory/Transfers/Approvals.vue";
import ViewTransfer from "@/views/Inventory/Transfers/ViewTransfer.vue";
import DownloadOrder from "@/components/Shop/DownloadOrder.vue";
import Departures from "@/views/Inventory/Departures.vue";
import InventoryInOutReport from "@/views/Inventory/Reports/InventoryInOutReport.vue";
const invetoryRoutes = {
  path: "/inventory",
  name: "Inventory",
  component: Inventory,
  meta: {
    libre: true
  },
  children: [
    {
      path: "variant",
      name: "Variant",
      component: Variant,
      meta: {
        code: "INV-12" // Cambiado de IVENTORY: true a un código específico
      },
    },
    {
      path: "departures",
      name: "Departures",
      component: Departures,
      meta: {
        code: "INV-14" // Cambiado de IVENTORY: true a un código específico
      },
    },
    {
      path: "download_order/:id",
      name: "DownloadOrder",
      component: DownloadOrder,
      meta: {
        libre: true
      },
    },
    {
      path: "category",
      name: "Category",
      component: Category,
      meta: {
        code: "INV-10" // Ya está bien
      },
    },
    {
      path: "view_adjustment/:id?",
      name: "ViewAdjustment",
      component: ViewAdjustment,
      meta: {
        code: "INV-041" // Cambiado de IVENTORY: true
      },
    },
    {
      path: "view_outflows/:id?",
      name: "ViewOutflows",
      component: ViewOutflows,
      meta: {
        code: "INV-14" // VER SALIDAS DE INVENTARIO (mismo acceso que la lista de salidas)
      },
    },
    {
      path: "view_transfer/:id?",
      name: "ViewTransfer",
      component: ViewTransfer,
      meta: {
        code: "INV-051" // Cambiado de IVENTORY: true
      },
    },
      {
                path: "assets",
                name: "Assets",
                component: Assets,
                meta: {
                  code: "INV-08" // C
                },
              },
    {
      path: "warehouse",
      name: "Warehouse",
      component: Warehouse,
      meta: {
        code: "INV-09" // Ya está bien
      },
    },
    {
      path: "catalogue",
      name: "Catalogue",
      component: Catalogue,
      meta: {
        code: "INV-11" // Ya está bien
      },
    },
    {
      path: "view_warehouse/:id",
      name: "ViewWarehouse",
      component: ViewWarehouse,
      meta: {
        code: "INV-091" // Cambiado de IVENTORY: true
      },
    },
    {
      path: "adjustments",
      name: "Adjustments",
      component: Adjustments,
      meta: {
        code: "INV-04" // Ya está bien
      },
    },
    {
      path: "ComboTransformation",
      name: "ComboTransformation",
      component: ComboTransformation,
      meta: {
        code: "INV-16" // Ya está bien
      },
    },
    {
      path: "transfer_request",
      name: "TransferRequest",
      component: TransferRequest,
      params: "type",
      meta: {
        code: "INV-05" // Ya está bien
      },
    },
    {
      path: "movement_locations",
      name: "MovementBtLocations",
      component: MovementBtLocations,
      params: "type",
      meta: {
        code: "INV-15" // MOVIMIENTOS ENTRE UBICACIONES (coincide con el menú); antes INV-05 (transferencias)
      },
    },
    {
      path: "transfer_received",
      name: "TransferReceivedt",
      component: TransferRequest,
      params: "type",
      meta: {
        code: "INV-07" // Ya está bien
      },
    },
    {
      path: "approvals",
      name: "Approvals",
      component: Approvals,
      meta: {
        code: "INV-06" // Ya está bien
      },
    },
    {
      path: "articles",
      name: "Articles",
      component: Articles,
      meta: {
        code: "INV-02" // Ya está bien
      },
    },
    {
      path: "inventory_management",
      name: "InventoryManagement",
      component: InventoryManagement,
      meta: {
        code: "INV-01" // Ya está bien
      },
    },
    {
      path: "article_conversions",
      name: "ArticleConversions",
      component: ArticleConversions,
      meta: {
        code: "INV-02" // Cambiado de IVENTORY: true
      },
    },
    {
      path: "reports/in-out",
      name: "InventoryInOutReport",
      component: InventoryInOutReport,
      meta: {
        code: "INV-01" // Reporte de Salidas/Entradas
      },
    },
  ],
}

export default invetoryRoutes